<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '440px' }"
  header="Asignar cartera"
>
  <div class="flex flex-column gap-2">
    <label class="font-medium">Cartera</label>
    <p-dropdown
      [options]="options"
      [(ngModel)]="selectedWalletId"
      optionLabel="name"
      optionValue="_id"
      [filter]="true"
      filterBy="name"
      [showClear]="false"
      [placeholder]="loadingOptions ? 'Cargando carteras…' : 'Selecciona una cartera'"
      appendTo="body"
      styleClass="w-full"
    ></p-dropdown>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" (click)="visible = false" [disabled]="saving"></button>
    <button pButton type="button" label="Asignar" icon="fa-solid fa-check" (click)="confirm()" [disabled]="!selectedWalletId || saving" [loading]="saving"></button>
  </ng-template>
</p-dialog>
